import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "mileage"
const MileageIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.375 18C6.996 18 7.5 18.504 7.5 19.125S6.996 20.25 6.375 20.25 5.25 19.746 5.25 19.125 5.754 18 6.375 18M10.125 18C10.746 18 11.25 18.504 11.25 19.125S10.746 20.25 10.125 20.25 9 19.746 9 19.125 9.504 18 10.125 18M13.875 18C14.496 18 15 18.504 15 19.125S14.496 20.25 13.875 20.25 12.75 19.746 12.75 19.125 13.254 18 13.875 18M17.625 18C18.246 18 18.75 18.504 18.75 19.125S18.246 20.25 17.625 20.25 16.5 19.746 16.5 19.125 17.004 18 17.625 18M6.375 6.75C7.203 6.75 7.875 7.422 7.875 8.25S7.203 9.75 6.375 9.75 4.875 9.078 4.875 8.25 5.547 6.75 6.375 6.75" />
          <path
            fillRule="evenodd"
            d="M6.375 3.375C8.902 3.375 10.875 5.394 10.875 8.25 10.875 9.97 9.997 11.81 9.112 13.16 8.661 13.85 8.183 14.45 7.767 14.887 7.56 15.102 7.354 15.292 7.164 15.434 7.069 15.504 6.964 15.574 6.852 15.63 6.752 15.679 6.582 15.75 6.375 15.75S5.997 15.679 5.898 15.63C5.786 15.575 5.68 15.505 5.585 15.434 5.395 15.292 5.19 15.102 4.983 14.886 4.567 14.45 4.09 13.85 3.638 13.16 2.753 11.809 1.875 9.97 1.875 8.25 1.875 5.394 3.848 3.375 6.375 3.375M6.375 4.875C4.76 4.875 3.375 6.135 3.375 8.25 3.375 9.53 4.06 11.066 4.893 12.34 5.301 12.962 5.723 13.488 6.067 13.85Q6.245 14.033 6.374 14.143 6.504 14.034 6.683 13.849C7.028 13.49 7.449 12.962 7.857 12.34 8.69 11.066 9.375 9.53 9.375 8.25 9.375 6.136 7.99 4.875 6.375 4.875"
            clipRule="evenodd"
          />
          <path d="M17.625 6.75C18.453 6.75 19.125 7.422 19.125 8.25S18.453 9.75 17.625 9.75 16.125 9.078 16.125 8.25 16.797 6.75 17.625 6.75" />
          <path
            fillRule="evenodd"
            d="M17.625 3.375C20.152 3.375 22.125 5.394 22.125 8.25 22.125 9.97 21.247 11.81 20.362 13.16 19.911 13.85 19.433 14.45 19.017 14.887 18.81 15.102 18.604 15.292 18.414 15.434 18.319 15.504 18.214 15.574 18.102 15.63 18.003 15.679 17.832 15.75 17.625 15.75S17.247 15.679 17.148 15.63C17.036 15.575 16.93 15.505 16.835 15.434 16.645 15.292 16.44 15.102 16.233 14.886 15.817 14.45 15.34 13.85 14.888 13.16 14.003 11.809 13.125 9.97 13.125 8.25 13.125 5.394 15.098 3.375 17.625 3.375M17.625 4.875C16.01 4.875 14.625 6.135 14.625 8.25 14.625 9.53 15.31 11.066 16.143 12.34 16.552 12.962 16.973 13.488 17.317 13.85Q17.495 14.033 17.624 14.143 17.754 14.034 17.933 13.849C18.278 13.49 18.699 12.962 19.107 12.34 19.94 11.066 20.625 9.53 20.625 8.25 20.625 6.136 19.24 4.875 17.625 4.875"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default MileageIcon
